export default {
    //设置路由名称
    ["SET_ROUTER_NAME"](states, params) {
        states.routerName = params;
    }
}




// WEBPACK FOOTER //
// ./src/store/navigation/mutations.js